import React from 'react'

const Unauthorised = () => (
    <div>Unauthorised</div>
)

export default Unauthorised